import Cookies from 'js-cookie'
import oauthConfig from '@/config/oauth'
import { getAuthorizationToken } from '@/utils/oauth'

const TokenKey = 'fm-Token'
const RefreshKey = 'Refresh-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRefreshToken() {
  return Cookies.get(RefreshKey)
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshKey, token)
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshKey)
}

// 获取OAuth认证令牌
export async function getOAuthToken() {
  try {
    // 首先尝试使用默认配置
    let token = await getAuthorizationToken(oauthConfig);
    
    if (token) {
      setToken(token);
      return token;
    } else {
      console.error('所有OAuth配置都失败，无法获取令牌');
      return null;
    }
  } catch (error) {
    console.error('获取OAuth令牌出错:', error);
    return null;
  }
}

export function setBusinessKYC(flag) {
  return Cookies.set("BusinessKYC", flag, 180)
}
export function setPersonalKYC(flag) {
  return Cookies.set("PersonalKYC", flag, 180)
}
export function getBusinessKYC() {
  return Cookies.get("BusinessKYC")
}
export function getPersonalKYC() {
  return Cookies.get("PersonalKYC")
}
export function getChainId() {
  return Cookies.get("TREASURE_CHAINID")
}

export function setChainId(data) {
  return Cookies.set("TREASURE_CHAINID", data)
}
